let load = (maxShards) => (id) => {
  // eslint-disable-next-line no-undef
  return __parcel__import__(
    require('atlaspack/lib/domain-sharding').shardUrl(
      require('../bundle-manifest').resolve(id),
      maxShards,
    ),
  );
};

module.exports = load;
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="5232780b-908f-5a3c-bef7-c7d7c1248a6d")}catch(e){}}();
//# debugId=5232780b-908f-5a3c-bef7-c7d7c1248a6d
